module.exports = __webpack_public_path__ + "static/media/logo.05b946a2.png";